import { Button, Pane, Text, Paragraph, Heading, Small } from 'evergreen-ui';
import { SuccessIcon } from '../../components/icons';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RegisterSuccessPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/app');
    }, 5000);
    return () => clearTimeout(timer);
  });

  return (
    <Pane
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      padding={16}
      paddingTop={0}
    >
      <SuccessIcon />
      <Heading color="#edeef2" size={700}>
        Invoice Successfully Sent!
      </Heading>
      <Paragraph color="#636465" textAlign="center" paddingY={32}>
        <Small>
          Redirecting to filters... click{' '}
          <Button
            appearance="minimal"
            color="#e78850"
            border="none"
            borderRadius={10}
            onClick={() => navigate('/app')}
            marginBottom={3}
            paddingX={2}
          >
            <Text color="#e78850">HERE</Text>
          </Button>{' '}
          if nothing happens
        </Small>
      </Paragraph>
    </Pane>
  );
};

export default RegisterSuccessPage;
